import { ShopSelectShopType } from "../enums";
import {
  LABEL_SHOP_REGULAR,
  LABEL_SHOP_COSMETIC,
  LABEL_SHOP_APTEKA,
  LABEL_SHOP_FAMILY,
  LABEL_SHOP_EXTRA,
  LABEL_SHOP_MASTER,
  LABEL_SHOP_WHOLESALE,
  LABEL_SHOP_V1,
  LABEL_SHOP_MYPRICE,
} from "./labels";

export const SHOPS_LIST_ITEM_HEIGHT = 92;
export const SHOPS_LIST_ITEM_TITLE_HEIGHT = 40;

export const SHOPS_LIST_SUM_PADDING = 40;
export const SHOPS_DETAILED_LIST_SCROLL_DIFF = 500;
export const SHOPS_DETAILED_LIST_ITEMS_OFFSET = 8;
export const SHOPS_DETAILED_LIST_ITEMS_PER_SLICE = 10;
export const SHOPS_LIST_SCROLL_THROTTLE_TIME = 200;
export const SHOPS_LIST_SCROLL_DISABLE_TIME = 500;

export const SHOPS_LIST_ITEM_WITH_TITLE_MAIN_HEIGHT =
  SHOPS_LIST_ITEM_HEIGHT + SHOPS_LIST_ITEM_TITLE_HEIGHT;
export const SHOPS_LIST_ITEM_WITH_TITLE_SECONDARY_HEIGHT =
  SHOPS_LIST_ITEM_WITH_TITLE_MAIN_HEIGHT - SHOPS_DETAILED_LIST_ITEMS_OFFSET;

export const SHOPS_NAMES_MAP: Record<ShopSelectShopType, string> = {
  [ShopSelectShopType.AtHouse]: LABEL_SHOP_REGULAR,
  [ShopSelectShopType.Cosmetic]: LABEL_SHOP_COSMETIC,
  [ShopSelectShopType.Pharmacy]: LABEL_SHOP_APTEKA,
  [ShopSelectShopType.Extra]: LABEL_SHOP_EXTRA,
  [ShopSelectShopType.Family]: LABEL_SHOP_FAMILY,
  [ShopSelectShopType.Master]: LABEL_SHOP_MASTER,
  [ShopSelectShopType.Wholesale]: LABEL_SHOP_WHOLESALE,
  [ShopSelectShopType.V1]: LABEL_SHOP_V1,
  [ShopSelectShopType.MyPrice]: LABEL_SHOP_MYPRICE,
};
